const Panel = require('../components/panel');
const Tempstop = require('../components/temporary-stop');
const throttle = require('lodash.throttle');

module.exports = {
  name: 'tabs',
  props: {
    routeData: {
      type: Array,
      required: true,
    },
    tempStopData: {
      type: Array,
      required: false,
    },
    allHeadsignData: {
      type: Array,
      required: true,
    },
    allServiceTimeData: {
      type: Array,
      required: true,
    },
    stopInfo: {
      type: Array,
      required: false,
    },
    goldenTrips: {
      type: Array,
      required: true,
    }
  },

  data() {
    return {
      selected_servicetime: null,
      selected_headsign: null,
      expanded: false,
    }
  },

  computed: {
    allHeadsigns() {
      // find all headsigns on current route
      const headsignsForRoute = [];
      // console.log('route data');
      // console.log(this.routeData);

      this.routeData.forEach(stop => {
        // console.log('stop headsign');
        // console.log(stop.headsign);
        //loop over each headsig and add it to the array, if it already exists skip and move on to the next iteration
        if (headsignsForRoute.indexOf(stop.headsign) === -1) {
          headsignsForRoute.push(stop.headsign);
        }
      });
      // console.log('headsignsForRoute');
      // console.log(headsignsForRoute);

      // filter mutable array of all headsigns against headsigns on this route
      const allHeadsignsMutable = this.allHeadsignData.filter(headsign => {
        // console.log('headsign.title ' + headsign.title);
        return headsignsForRoute.indexOf(headsign.title) !== -1;
      });
      // console.log('all highsigns are proper now, limit was 10 in drupal view');

      // all headsign data should come presorted from drupal api
      // but let's make sure to sort it just in case
      allHeadsignsMutable.sort((a, b) => {
        const seqA = parseInt(a.field_sort_order);
        const seqB = parseInt(b.field_sort_order);
        if (seqA < seqB) {
          return -1;
        }
        if (seqA > seqB) {
          return 1;
        }
        // sequence must be equal
        return 0;
      });

      // console.log('allHeadsignsMutable after sort');
      // console.log(allHeadsignsMutable);

      return allHeadsignsMutable;
    },

    allServiceTimes() {
      const serviceTimesForRoute = [];
      this.routeData.forEach(stop => {
        if (serviceTimesForRoute.indexOf(stop.service_time_name) === -1) {
          serviceTimesForRoute.push(stop.service_time_name);
        }
      });

      // console.log('serviceTimesForRoute');
      // console.log(serviceTimesForRoute);

      // filter mutable array of all service times against headsigns on this route
      const allServiceTimesMutable = this.allServiceTimeData.filter(servicetime => {
        return serviceTimesForRoute.indexOf(servicetime.field_nice_name) !== -1;
      });
      // all service time data should come presorted from drupal api
      // but let's make sure to sort it just in case
      allServiceTimesMutable.sort((a, b) => {
        const seqA = parseInt(a.field_sort_order);
        const seqB = parseInt(b.field_sort_order);
        if (seqA < seqB) {
          return -1;
        }
        if (seqA > seqB) {
          return 1;
        }
        // sequence must be equal
        return 0;
      });

      // console.log('allServiceTimesMutable');
      // console.log(allServiceTimesMutable);

      return allServiceTimesMutable;
    },

    goldenTrip() {
      const servicetime = this.selected_servicetime.toLowerCase();
      // console.log('servicetime ' + servicetime);
      const headsign = this.selected_headsign.toLowerCase();
      // console.log('tabsjs headsign ' + headsign);
      // console.log(`${servicetime}\n${headsign}`);
      // console.log(this.goldenTrips);
      // console.log(this.goldenTrips[servicetime][headsign]);
      return this.goldenTrips[servicetime][headsign];
    }
  },

  created: function () {
    // this selects the first service time and headsign on creation as default values
    if (this.allServiceTimes.length > 0 && this.allHeadsigns.length > 0) {
      this.selected_servicetime = this.allServiceTimes[0].field_nice_name;
      this.selected_headsign = this.allHeadsigns[0].title;
    }
    // console.log('tabs vue component created');
  },

  mounted: function() {
      // console.log('on mounted');
      // console.log('goldenTrips');
      // console.log(this.goldenTrips);
      // console.log('selected_servicetime ' + this.selected_servicetime );
      // console.log('selected_headsign ' +  this.selected_headsign );
      // console.log('prop allHeadsignData ');
      // console.log(this.allHeadsignData);
      // console.log('prop allHeadsigns ');
      // console.log(this.allHeadsigns);

    if (this.allServiceTimes.length > 0 && this.allHeadsigns.length > 0) {
      $scrollbarHandle = $('.scrollbar__icon');
      $itemsToHideWhenNoScroll = $('.scrollbar, .gradient, .move-row-icon');

      initDraggableRows();
      attachGradientClickHandler();
      addKeyListener();
      // attach resize handler inside mounted so it is only added when needed
      // reset draggable on resize
      $(window).resize(throttle(initDraggableRows, 1000, { 'trailing': true }));
    }
  },

  updated: function() {
    if (this.allServiceTimes.length > 0 && this.allHeadsigns.length > 0) {
      // refetch items to hide when there's no scroll
      // the .gradient div is regenerated on each update because it's located
      // inside the city div
      $itemsToHideWhenNoScroll = $('.scrollbar, .gradient, .move-row-icon');
      initDraggableRows();

    }
  },

  methods: {
    handleClick(propertyName, value, event) {
      return (event) => {
        event.preventDefault();
        this[propertyName] = value;
        // console.log('updated clicked ' + value)
      };
    },

    toggleStops(e) {
      this.expanded = !this.expanded;
    },
  },

  render() {
    const dataFiltered =
      this.routeData.filter(stop => {
        let filteredServicetime = this.selected_servicetime;
        // console.log('this.selected_servicetime');
        // console.log(filteredServicetime);

        if (filteredServicetime == 'Mon-Fri' || filteredServicetime == 'Saturday') {
          return stop.headsign == this.selected_headsign && (stop.service_time_name == filteredServicetime || stop.service_time_name == 'Mon-Sat');
        }
        return stop.headsign == this.selected_headsign && stop.service_time_name == filteredServicetime;
    })
    // console.log('dataFilterd');
    // console.log(dataFiltered);

    return (
      <div class="route-page__schedule">

        <div class="schedule__tabs">
          <div class="schedule__tabs--serive-time">
            {this.allServiceTimes.map((serviceTime, index) =>
              <a ref="tabItem" class={{tab:true, active:this.selected_servicetime===serviceTime.field_nice_name}} data-type='service-time-name' data-value={serviceTime.field_nice_name} onClick={this.handleClick('selected_servicetime', serviceTime.field_nice_name)} href="#">{serviceTime.field_nice_name}</a>
            )}
          </div>

          <div class="schedule__tabs--headsign">

            {this.allHeadsigns.map((headsign, index) =>
              <a ref="tabItem" class={{tab:true, active:headsign.title===this.selected_headsign}} data-type='headsign' data-value={headsign.title} onClick={this.handleClick('selected_headsign', headsign.title, this)}  href="#">{headsign.title}</a>
            )}
          </div>
        </div>

        <div class="schedule" ref="schedule">
        {/*dataFiltered.length > 0 ? 'true' : 'false'*/}

        {dataFiltered.length > 0 ? <Panel
          stoptimes={dataFiltered}
          expanded={this.expanded}
          stopInfo={this.stopInfo}
          goldenTrip={this.goldenTrip}
          /> : <p>There is not a schedule for that day.</p>}
        </div>

        {this.expanded &&
          <p class="approx-note">*** italic times are approx.</p>
        }

        {this.tempStopData.length >= 1 &&
          this.expanded &&
            <Tempstop tempStopData={this.tempStopData} />
        }

        <a class={`toggle-stops ${this.expanded ? 'open' : 'closed'}`} ref="stopToggle" onClick={this.toggleStops}>
          <span class="expand-icon"></span>{this.expanded ? "Collapse All Stops" : "View All Stops. Stops Listed Above are Timed Stops."}
        </a>

        <div class="scrollbar"><div class="scrollbar__icon"><span class="icon-arrow-left"></span><span class="icon-arrow-right"></span></div></div>
      </div>
    );
  },
};

// global vars for draggeble elements
let draggableEls;
let firstVisibleRow;
let firstVisibleRowInner;
let stopTimesWidth;
let visibleArea;
let leftOffset;
// vars for scrollbar
let $scrollbarHandle;
let scrollBarWidth;
let $itemsToHideWhenNoScroll;
let atEnd = false;

// control with keys
function addKeyListener() {
  document.addEventListener('keydown', function(event) {
    switch(event.keyCode) {
      case 37: // left
          moveRows('right', event.shiftKey);
          break;
      case 39: // right
          moveRows('left', event.shiftKey);
          break;
    }
  });
}

// jquery draggable function
function initDraggableRows() {
  // all elements to be draggable
  draggableEls = $('.stop-times-row .stop-times-row__inner');
  // use the first visible row to make calcs on - each row will be the same width
  firstVisibleRow = $('[data-timepoint="exact"]').first();
  // this is the selector for the div around all the stop times
  firstVisibleRowInner = firstVisibleRow.find('.stop-times-row__inner');
  // clear any inline left styles
  draggableEls.css({'left': ''});
  // set up area the row can move around in
  // gives us the locations of the left side of the row relative to the document
  leftOffset = firstVisibleRowInner.offset().left;
  // width of all the stop times
  stopTimesWidth = firstVisibleRowInner.outerWidth();
  // width the area that is visible in the table
  visibleArea = firstVisibleRow.outerWidth() - firstVisibleRow.find('.stop-name').outerWidth();

  draggableEls.each(function(index, el) {
    const $this = $(el);
    // if this draggable exists, destroy it and reattach to avoid jank w/ vue swapping out dom items
    if($this.draggable('instance') != undefined) {
      $this.draggable('destroy');
    }
    // check if we need to be able to scroll
    if (stopTimesWidth > visibleArea) {
      // make sure scrollbar is visible (it will be hidden if not needed)
      scrollControlElements('show');

      // set up top left and bottom right points the row can move within
      const y1 = $this.offset().top;
      const x1 = leftOffset - (stopTimesWidth - visibleArea);
      const y2 = y1;
      const x2 = leftOffset;
      // instantiate the draggable elements
      $(el).draggable({
        containment: [x1, y1, x2, y2],
        axis: 'x',
        drag: function(e, ui) {
          // move all rows the same as this row was moved
          draggableEls.not($this).css({
            'left': ui.helper.css('left')
          });
          // move scroll bar handle to match the rows movment
          const moveScollBarHandleTo = calcLeftAsPx(ui.position.left * -1, scrollBarWidth, x2 - x1);
          // assign movement value to rows, inversing px value
          $scrollbarHandle.css({
            'left': moveScollBarHandleTo
          });

          // check if we're at the end, add classes as needed
          checkIfScrolledToEndOfRow(ui.position.left, x1-x2);
        },
        // make sure they all line up after dragging stops
        stop: function(e, ui) {
          // move all rows the same as this row was moved
          draggableEls.not($this).css({
            'left': ui.helper.css('left')
          });
          // move scroll bar handle to match the rows movment
          const moveScollBarHandleTo = calcLeftAsPx(ui.position.left * -1, scrollBarWidth, x2 - x1);
          // assign movement value to rows, inversing px value
          $scrollbarHandle.css({
            'left': moveScollBarHandleTo
          });

          // check if we're at the end, add classes as needed
          checkIfScrolledToEndOfRow(ui.position.left, x1-x2);
        },
      });
      // call the drag bar function
      initDragBar();
    } else {
      // if visible area is wider than stop times row and scroll bar exists, hide the scroll bar
      scrollControlElements('hide');
      // console.log('here');
    }
  });
}

// controls a class and hides/shows divs if they're not needed because the whole schedule fits on the page
function scrollControlElements(whatToDo) {
  if (whatToDo == 'hide') {
    $('.stop-times-row__inner, .stop-name').addClass('no-scroll');
    $itemsToHideWhenNoScroll.hide();
  }

  if (whatToDo == 'show') {
    $('.stop-times-row__inner, .stop-name').removeClass('no-scroll');
    $itemsToHideWhenNoScroll.show();
  }
}

function checkIfScrolledToEndOfRow(currentLeft, maxLeft) {
  // console.log(`currentLeft: ${currentLeft}`);
  // console.log(`maxLeft: ${maxLeft}`);

  if (currentLeft < maxLeft + 10  && atEnd === false) {
      $('.gradient').addClass('at-end');
      atEnd = true;
    }

    if (currentLeft > maxLeft + 10  && atEnd === true) {
      $('.gradient').removeClass('at-end');
      atEnd = false;
    }
}

function initDragBar() {
  $scrollbarHandle = $('.scrollbar__icon');
  scrollBarWidth = $scrollbarHandle.parent().width() - $scrollbarHandle.outerWidth();
  // same as x2 - x1 - gives us max movement value
  const maxLeft = leftOffset - (leftOffset - (stopTimesWidth - visibleArea));

  // destroy if already instansiated
  if($scrollbarHandle.draggable('instance') != undefined) {
    $scrollbarHandle.draggable('destroy');
  }
  // clear any inline left styles
  $scrollbarHandle.css({'left': ''});

  $scrollbarHandle.draggable({
    axis: 'x',
    containment: 'parent',
    drag: function(e, ui) {
      const moveRowTo = calcLeftAsPx(ui.position.left, maxLeft, scrollBarWidth);
      // assign movement value to rows, inversing px value
      draggableEls.css({
        'left': `-${moveRowTo}`
      });
    },

    stop: function(e, ui) {
      const moveRowTo = calcLeftAsPx(ui.position.left, maxLeft, scrollBarWidth);
      draggableEls.css({
        'left': `-${moveRowTo}`
      });

      // check if we're at the end, add classes as needed
      checkIfScrolledToEndOfRow(parseInt(moveRowTo)*-1, maxLeft*-1);
    },
  })
}

function calcLeftAsPx(currentLeft, maxLeft, fullWidth) {
  const percent = (currentLeft / fullWidth);
  const pxValue = maxLeft * percent;
  return `${pxValue}px`;
}

function moveRows(direction, bigMove) {
  const multiplier = direction === 'right' ? 1 : -1;
  let moveBy = 25 * multiplier;
  // move faster if shift key is held
  if (bigMove) {
    moveBy = 120 * (direction === 'right' ? 1 : -1);
  }
  const leftPosition = parseInt(draggableEls.first().css('left'), 10);
  const maxLeft = (leftOffset - (leftOffset - (stopTimesWidth - visibleArea))) * -1;
  let leftValToMoveTo;

  if (direction === 'right') {
    if(leftPosition + moveBy < 0) {
      leftValToMoveTo = leftPosition + moveBy;
      draggableEls.css({
        'left': `${leftValToMoveTo}px`
      });
    } else if (leftPosition < 0) {
      leftValToMoveTo = 0;
      draggableEls.css({
        'left': `${leftValToMoveTo}px`
      });
    } else {
      // alert('maxed outed going right');
    }
  }

  if (direction === 'left') {
    if(leftPosition + moveBy > maxLeft) {
      leftValToMoveTo = leftPosition + moveBy;
      // console.log(leftValToMoveTo);
      draggableEls.css({
        'left': `${leftValToMoveTo}px`
      });
    } else if (leftPosition > maxLeft) {
      leftValToMoveTo = leftPosition - (leftPosition - maxLeft);
      draggableEls.css({
        'left': `${leftValToMoveTo}px`
      });
    } else {
      // alert('maxed outed going left');
    }
  }

  // check if we're at the end, add classes as needed
  checkIfScrolledToEndOfRow(leftValToMoveTo, maxLeft);

  // move scroll bar handle to match the rows movment
  const moveScollBarHandleTo = calcLeftAsPx(leftValToMoveTo * -1, scrollBarWidth, leftOffset - (leftOffset - (stopTimesWidth - visibleArea)));
  // assign movement value to rows, inversing px value
  $scrollbarHandle.css({
    'left': moveScollBarHandleTo
  });

}

function attachGradientClickHandler() {
  $('.move-row-icon').on('click', () => {
    moveRows('left', false)
  });
}
